export const COOKIE_UPDATED = "29 June 2026";

export const COOKIE_INTRO = [
  'This Cookie Policy explains how Harman AI Solutions ("we", "us", or "our") uses cookies and similar tracking technologies when you visit our website at https://harmanaisolutions.com.',
];

export const COOKIE_SECTIONS = [
  {
    title: "What Are Cookies?",
    paras: [
      "Cookies are small text files that are placed on your device (computer, tablet, or mobile phone) when you visit a website. They are widely used to make websites work more efficiently and to provide information to website owners.",
      "Cookies do not contain any information that personally identifies you directly, but personal information that we store about you may be linked to information stored in and obtained from cookies.",
    ],
  },
  {
    title: "What Cookies Do We Use?",
    subsections: [
      {
        heading: "Essential Cookies",
        paras: [
          "These cookies are necessary for the website to function properly. Without them, certain parts of the site would not work. They do not collect any personal information and cannot be switched off.",
        ],
        table: {
          headers: ["Cookie", "Purpose", "Duration"],
          rows: [["Session cookies", "Maintain basic website functionality", "Session (deleted when browser closes)"]],
        },
      },
      {
        heading: "Analytics Cookies",
        paras: [
          "These cookies allow us to count visits and understand how visitors use our website, so we can measure and improve its performance. All information collected is aggregated and anonymous.",
        ],
        table: {
          headers: ["Cookie", "Provider", "Purpose", "Duration"],
          rows: [
            ["_ga", "Google Analytics", "Distinguishes unique users", "2 years"],
            ["_ga_*", "Google Analytics", "Maintains session state", "2 years"],
            ["_gid", "Google Analytics", "Distinguishes unique users", "24 hours"],
            ["_gat", "Google Analytics", "Throttles request rate", "1 minute"],
          ],
        },
        after: [
          "We use Google Analytics to understand how visitors interact with our website. Google Analytics uses cookies to collect information about your visit, including which pages you viewed, how long you spent on each page, and how you arrived at the site. This information is used to compile reports and help us improve the website.",
        ],
        afterLink: { label: "Google Privacy Policy", url: "https://policies.google.com/privacy" },
      },
    ],
  },
  {
    title: "How To Control Cookies",
    subsections: [
      {
        heading: "Browser Settings",
        paras: ["You have the right to decide whether to accept or decline cookies. You can exercise your cookie preferences in the following ways:"],
        links: [
          { label: "Google Chrome", url: "https://support.google.com/chrome/answer/95647" },
          { label: "Mozilla Firefox", url: "https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" },
          { label: "Safari", url: "https://support.apple.com/en-gb/guide/safari/sfri11471/mac" },
          { label: "Microsoft Edge", url: "https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" },
        ],
      },
      {
        heading: "Opting Out of Google Analytics",
        paras: ["You can prevent Google Analytics from collecting data about your visit by installing the Google Analytics Opt-out Browser Add-on, available at:"],
        link: { label: "Google Analytics Opt-out Browser Add-on", url: "https://tools.google.com/dlpage/gaoptout" },
      },
    ],
  },
  {
    title: "Third-Party Cookies",
    paras: [
      "Our website may contain links to third-party websites. These third-party sites have their own cookie policies and we have no control over the cookies they place on your device. We recommend you check the cookie policies of any third-party websites you visit.",
    ],
  },
  {
    title: "Updates To This Policy",
    paras: [
      "We may update this Cookie Policy from time to time to reflect changes in technology, law, or our use of cookies. Any changes will be posted on this page with an updated date at the top. We encourage you to review this policy periodically.",
    ],
  },
  {
    title: "Contact Us",
    paras: ["If you have any questions about our use of cookies, please contact us at:"],
    contact: {
      name: "Harman AI Solutions",
      address: "Edinburgh, Scotland, United Kingdom",
      email: "team@harmanaisolutions.com",
      website: "https://harmanaisolutions.com",
    },
  },
];
